import script from "./AppRoute.vue?vue&type=script&setup=true&lang=js"
export * from "./AppRoute.vue?vue&type=script&setup=true&lang=js"

import "./AppRoute.vue?vue&type=style&index=0&id=dcbf05d4&scoped=true&lang=css"
script.__scopeId = "data-v-dcbf05d4"

export default script